// GENERATED by scripts/build-icons.mjs from icons/external-link.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const ExternalLink = createIcon('external-link', [
  ['path', { d: "M15 3h6v6" }],
  ['path', { d: "M10 14 21 3" }],
  ['path', { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }],
])
